<template>
  <v-btn
    :disabled="isDisabled"
    color="primary"
    flat>
    {{ label }}&nbsp;&nbsp;
    <v-progress-circular
      v-if="saveState === 'saving'"
      :size="15"
      :width="2"
      color="secondary"
      indeterminate />
    <v-icon v-if="saveState === 'saved'">done</v-icon>
  </v-btn>
</template>

<script>
// 4 possible cases
// unchanged: no changes since opening the component
// changed: unsaved changes made
// saving: save ongoing
// saved: all changes saved

export default {
  name: "SaveButton",
  props: {
    saveState: {
      type: String,
      required: false,
      default: "unchanged"
    }
  },
  data: () => ({
    saving: false
  }),
  computed: {
    label() {
      if (this.saveState === "unchanged") return "Opslaan";
      if (this.saveState === "saving") return "Aan het opslaan...";
      if (this.saveState === "saved") return "Opgeslagen";
      return "Opslaan";
    },
    isDisabled() {
      if (this.saveState === "changed") return false;
      return true;
    }
  }
};
</script>
